import React from 'react';

import { VStack } from '@chakra-ui/react';
import { useFormState } from 'react-final-form';

import Page from 'components/Page/Page';
import PageTitle from 'components/PageTitle/PageTitle';
import { translations } from 'new/form/common/types';
import { InquirySummarySections } from 'new/summary/components/SummarySections';
import SummaryHeading from 'pages/inquiryFlow/SummaryPage/SummaryHeading/SummaryHeading';
import { useScrollToTop } from 'utils/hooks/useScrollToTop';
import { useTranslations } from 'utils/hooks/useTranslations';

import { SummaryActions } from './components/SummaryActions';
import { SummaryStepProvider } from './SummaryPageContext';

export const SummaryPage = <FieldTypes,>() => {
  const t = useTranslations();
  const { values } = useFormState<FieldTypes>();
  useScrollToTop();

  return (
    <Page hero={<SummaryHeading />}>
      <PageTitle title={t(translations.pages.inquiryDetails.detailed.summary.title)} />
      <VStack gap={4}>
        <SummaryStepProvider<FieldTypes> values={values}>
          <InquirySummarySections />
        </SummaryStepProvider>
        <SummaryActions />
      </VStack>
    </Page>
  );
};
